import { render, staticRenderFns } from "./ExportDemandFile.vue?vue&type=template&id=b2cc7022"
import script from "./ExportDemandFile.vue?vue&type=script&lang=js"
export * from "./ExportDemandFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports